import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Table from '../../../../core/form/Table';
import { round } from 'lodash';
import Button from '../../../../core/form/Button';
import Dialog from '../../../../core/layout/Dialog';
import { Rate } from 'antd';

function RateItemButton(props) {
  return (
    <div
      style={{
        display: 'flex',
        columnGap: 15,
        alignItems: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          columnGap: 10,
          alignItems: 'center',
        }}
      >
        <span style={{ width: 30 }}>({props.count})</span>
        <Rate defaultValue={props.score} disabled />
      </div>
      <Button icon="caret-right" onClick={() => props.onClick(props.score)} size="sm" />
    </div>
  );
}
function UnitRatingsList(props) {
  const [selectedUnit, setSelectedUnit] = useState();
  const [selectedRating, setSelectedRating] = useState();

  return (
    <>
      <Table
        fetching={props.fetching}
        columns={[
          {
            label: 'Module Group',
            path: 'module.group',
            sort: true,
            width: '140px',
          },
          {
            label: 'Module',
            path: 'module.name',
            sort: true,
          },
          {
            label: 'Unit',
            path: 'name',
            sort: true,
          },
          {
            label: 'Unit Group',
            path: 'group',
            width: '120px',
            sort: true,
          },
          {
            label: 'Unit order',
            path: 'order',
            width: '120px',
            sort: true,
          },
          {
            label: 'Type',
            path: 'type.name',
            sort: true,
          },
          {
            label: 'Total',
            path: 'count',
            width: '120px',
            sort: true,
          },
          {
            label: 'Rate',
            path: 'avgScore',
            render: (value, row) => (value ? round(value, 2) : 0),
            width: '120px',
            sort: true,
          },
          {
            label: 'Actions',
            path: 'action',
            render: (cell, row, index) => <Button icon="eye" onClick={() => setSelectedUnit(row)} />,
          },
        ]}
        rows={props.units}
      />
      <Dialog
        title={`${selectedUnit?.name} - Rating details`}
        isOpen={!!selectedUnit}
        onCancel={() => setSelectedUnit(undefined)}
        width="80%"
      >
        {!!selectedUnit && (
          <div
            style={{
              display: 'flex',
              columnGap: 15,
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                rowGap: 10,
              }}
            >
              <RateItemButton
                score={5}
                count={selectedUnit.ratings.filter((r) => r.score === 5).length}
                onClick={setSelectedRating}
              />
              <RateItemButton
                score={4}
                count={selectedUnit.ratings.filter((r) => r.score === 4).length}
                onClick={setSelectedRating}
              />
              <RateItemButton
                score={3}
                count={selectedUnit.ratings.filter((r) => r.score === 3).length}
                onClick={setSelectedRating}
              />
              <RateItemButton
                score={2}
                count={selectedUnit.ratings.filter((r) => r.score === 2).length}
                onClick={setSelectedRating}
              />
              <RateItemButton
                score={1}
                count={selectedUnit.ratings.filter((r) => r.score === 1).length}
                onClick={setSelectedRating}
              />
            </div>
            <div style={{ width: 1, display: 'flex', backgroundColor: '#cecece' }} />
            {!!selectedRating ? (
              <div
                style={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  rowGap: 10,
                }}
              >
                {!!selectedUnit.ratings.filter((r) => r.score === selectedRating && r.comment).length ? (
                  selectedUnit.ratings
                    .filter((r) => r.score === selectedRating && r.comment)
                    .map((r) => (
                      <>
                        <label>{r.comment}</label>
                        <div style={{ height: 1, display: 'flex', backgroundColor: '#cecece' }} />
                      </>
                    ))
                ) : (
                  <h3>No comments available</h3>
                )}
              </div>
            ) : (
              <h3>Select a score to see available comments</h3>
            )}
          </div>
        )}
      </Dialog>
    </>
  );
}

UnitRatingsList.propTypes = {
  units: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    })
  ).isRequired,
  fetching: PropTypes.bool.isRequired,
};

export default UnitRatingsList;
